module.exports = __webpack_public_path__ + "img/4.c016ede0.jpg";